import { useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import API from '../../../Utils/api';
import { Button, Field } from '../../../Components/AdminSurface';
import styles from './UserSearchPage.module.css';

// Inline (not a portal modal) so the form stays inside the scoped Admin surface and its tokens.
export default function InviteUserPanel({ id, onCreated, onCancel }) {
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting }
    } = useForm({ defaultValues: { type: 'Athlete' } });

    const formRef = useRef(null);
    useEffect(() => formRef.current?.querySelector('input')?.focus(), []);

    const addUser = async ({ email, firstName, lastName, type }) => {
        try {
            const { data } = await API.createAccount({ email, firstName, lastName, type });
            toast.success('OK', { position: 'bottom-center' });
            onCreated({ _id: data.id, email, firstName, lastName, type, status: 'Inactive' });
        } catch (error) {
            toast.error(error?.response?.data?.error, { position: 'bottom-center' });
        }
    };

    return (
        <form
            ref={formRef}
            id={id}
            className={styles.invite}
            onSubmit={handleSubmit(addUser)}
            onKeyDown={e => e.key === 'Escape' && onCancel()}
            noValidate
        >
            <Field label="Email" type="text" error={errors.email && 'Email is required'} {...register('email', { required: true })} />
            <Field label="First Name" type="text" error={errors.firstName && 'First name is required'} {...register('firstName', { required: true })} />
            <Field label="Last Name" type="text" error={errors.lastName && 'Last name is required'} {...register('lastName', { required: true })} />
            <Field label="Account type" as="select" {...register('type', { required: true })}>
                <option value="Athlete">Athlete</option>
                <option value="Coach">Coach</option>
                <option value="Admin">Admin</option>
            </Field>
            <div className={styles.inviteActions}>
                <Button type="submit" variant="primary" busy={isSubmitting}>
                    Create account
                </Button>
                <Button onClick={onCancel}>Cancel</Button>
            </div>
        </form>
    );
}
